import React, {useEffect, useState} from 'react';
import {Link, useHistory} from 'react-router-dom';
import TaskAnswerList from './AnswerList';
import {QUERY_TASK_LIST, MUTATION_ANSWER_MASS_CREATE} from './graphql';
import {useQuery, useMutation, useLazyQuery} from '@apollo/client';
import Query from '../../components/Query';
import TaskItemStatic from './ItemStatic';
import TaskItemDynamic from './ItemDynamic';
import {QUERY_STUDY_DETAIL, QUERY_STUDY_LIST} from '../Study/graphql';
import Icon from '../../components/Icon';
import {QUERY_USER} from '../Client/graphql';
import {isActive} from '../Client/utils';
import {TouchBackend} from 'react-dnd-touch-backend';
import {DndProvider} from 'react-dnd';
import { locale } from '../../utils/joyride';
import Joyride, { ACTIONS, EVENTS, ORIGIN, STATUS } from "react-joyride";

const TaskList = ({kind, nextRun, lesson, study}) => {
  const {user} = useQuery(QUERY_USER).data;

  const [steps, setSteps] = useState([]);
  const [stepIndex, setStepIndex] = useState(0);
  const [run, setRun] = useState(false);
  const [answers, setAnswers] = useState([]);
  const [showHints, setShowHints] = useState(false);
  const [selectedWord, setSelectedWord] = useState('');

  const [getStudies] = useLazyQuery(QUERY_STUDY_LIST, {fetchPolicy: 'cache-and-network'});
  const [getUser] = useLazyQuery(QUERY_USER, {fetchPolicy: 'cache-and-network'});

  useEffect(() => {
    // setRun(!!(study && (kind === 'VOCABULARY' && !study.vocabularyPassed && nextRun === 'vocabulary')));
  }, [nextRun]);

  // useEffect(() => {
  //   if (study && study.trialPassed) {
  //     setSteps([...steps, {
  //       target: '.final-test',
  //       content: 'В vocabulary мы будем знакомиться с особенностями произношения. Прочтите материал. Так как это Урок-вступление, обьем материала символически',
  //       disableBeacon: true,
  //     }]);
  //   }
  // }, [study]);

  useEffect(() => {
    if (study) {
      if (kind === 'TRIAL' && nextRun === 'grammar') {
        if (!study.trialPassed) {
          setSteps([
            {
              target: '.col-lg-5.border',
              content: 'Нажмите на один из вариантов ответа, затем на пустую ячейку',
              disableBeacon: true,
            },
            {
              target: '.col-lg-7.border',
              content: 'Затем нажмите "проверить". Если есть ошибки - исправьте, и заново нажмите "проверить"',
              disableBeacon: true,
            },
          ]);
          setStepIndex(0);
          setTimeout(() => {
            setRun(true);
          }, 300);
        } else {
          setSteps([
            {
              target: '.final-test',
              content: 'Теперь настало время финального теста',
              disableBeacon: true,
            },
          ]);
          setStepIndex(0);
          setTimeout(() => {
            setRun(true);
          }, 300);
        }
      }

      else if (kind === 'FINAL' && nextRun === 'grammar' && !study.finalPassed) {
        // setSteps([
        //   {
        //     target: '.col-lg-5.border',
        //     content: 'Нажмите на один из вариантов ответа, затем на пустую ячейку',
        //     disableBeacon: true,
        //   },
        //   {
        //     target: '.col-lg-7.border',
        //     content: 'Затем нажмите "проверить". Если есть ошибки - исправьте, и заново нажмите "проверить"',
        //     disableBeacon: true,
        //   },
        // ]);
        // setStepIndex(0);
        // setTimeout(() => {
        //   setRun(true);
        // }, 300);
      }

      else if (nextRun === 'vocabulary' && !study.vocabularyPassed) {
        setSteps([
          {
            target: '.col-lg-5.border',
            content: 'Нажмите на один из вариантов ответа, затем на пустую ячейку',
            disableBeacon: true,
          },
          {
            target: '.col-lg-7.border',
            content: 'Затем нажмите "проверить". Если есть ошибки - исправьте, и заново нажмите "проверить"',
            disableBeacon: true,
          },
        ]);
        setStepIndex(0);
        setTimeout(() => {
          setRun(true);
        }, 300);
      }
      
    }
  }, [study, nextRun]);

  const query = useQuery(QUERY_TASK_LIST, {
    variables: {kind, lessonId: lesson.id},
    fetchPolicy: 'network-only',
    onCompleted: data => {
      if (data.taskList) {
        setAnswers(data.taskList.map(item => ({hint: item.hint, task: item, words: item.words})));
      }
    },
  });

  const [mutation, {loading}] = useMutation(MUTATION_ANSWER_MASS_CREATE, {
    onCompleted: data => {
      if (data && data.answerMassCreate && data.answerMassCreate.obj) {
        setAnswers(
          answers.map(answer => ({
            ...answer,
            isRight: (data.answerMassCreate.obj.find(x => x.taskId === answer.task.id) || {}).isRight,
          })),
        );
        getStudy({variables: {id: study && study.id}});
      }
    },
  });

  const [getStudy] = useLazyQuery(QUERY_STUDY_DETAIL, {
    fetchPolicy: 'cache-and-network',
    onCompleted: data => {
      const {vocabularyPassed, trialPassed, finalPassed, phoneticsPassed} = data.studyDetail;
      if (vocabularyPassed && trialPassed && finalPassed && phoneticsPassed) {
        getUser();
        getStudies();
      }
    },
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [tasksPerPage] = useState(5);

  const indexOfLastTask = currentPage * tasksPerPage;
  const indexOfFirstTask = indexOfLastTask - tasksPerPage;

  const [hideAnswers, setHideAnswers] = useState(true);

  const kindData = {
    TRIAL: {
      name: 'Практическое занятие',
      back: 'grammar',
      pass: lesson.trialPass,
    },
    FINAL: {
      name: 'Финальный тест',
      back: 'grammar',
      pass: lesson.finalPass,
    },
    VOCABULARY: {
      name: 'Тест лексики',
      back: 'vocabulary',
      pass: lesson.vocabularyPass,
    },
    INTERMEDIATE: {
      name: '',
      back: '',
      pass: lesson.intermediatePass,
    },
  };

  if (!isActive(user) && lesson.level > 10) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center">
        <div className="font-4 mb-4">Сейчас вам доступно 10 уроков, после активации будут доступны все 75</div>
        {kind === 'INTERMEDIATE' ? (
          <Link to={`/my-lessons`} replace className="btn btn-light ms-3">
            Назад
          </Link>
        ) : (
          <Link to={`/my-lessons/${lesson.id}/${kindData[kind].back}`} replace className="btn btn-light ms-3">
            Назад
          </Link>
        )}
      </div>
    );
  }

  const handleJoyrideCallback = data => {
    const { action, index, origin, status, type } = data;

    if (action === ACTIONS.CLOSE && origin === ORIGIN.KEYBOARD) {
      // do something
    }

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      // Update state to advance the tour
      const nextStep = index + (action === ACTIONS.PREV ? -1 : 1);
      setStepIndex(nextStep);
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // You need to set our running state to false, so we can restart if we click start again.
      setRun(false);
    }

    // console.groupCollapsed(type);
    // console.log(data); //eslint-disable-line no-console
    // console.groupEnd();
  };

  const answerList = answers.slice(indexOfFirstTask, indexOfLastTask);

  if (!study) return null;

  return (
    Query(query) || (
      <DndProvider backend={TouchBackend} options={{enableMouseEvents: true}}>
        <Joyride 
          run={run} 
          steps={steps} 
          stepIndex={stepIndex} 
          locale={locale} 
          callback={handleJoyrideCallback}
          scrollOffset={80}
        />
        <div className="text-center text-uppercase font-4 fw-bold mb-4">{kindData[kind].name}</div>
        <div className="text-center text-secondary mb-4">
          Нажмите на вариант ответа, затем на пустую ячейку
          <span className="text-warning fw-bold"> (оранжевые)</span>
        </div>
        <div className="mb-3">
          <button
            className="btn btn-info text-white btn-sm"
            onClick={() => {
              setShowHints(!showHints);
            }}
          >
            {!showHints ? 'Показать доп. информацию' : 'Скрыть доп. информацию'}
          </button>
        </div>
        <div className="container mb-5">
          <div className="row flex-wrap">
            <div className="col-lg-7 border p-3">
              <div>
                {answerList.map((answer, answer_i) => (
                  <div key={answer_i} className="mb-2 d-flex align-items-center">
                    <div className="me-3 d-flex">
                      <span>{indexOfFirstTask + answer_i + 1}.</span>
                    </div>
                    <div className="flex-grow-1">
                      <div className="d-flex flex-wrap flex-grow-1">
                        {answer.words.map((word, word_i) =>
                          word !== '_' && word[0] !== '~' ? (
                            <TaskItemStatic key={word_i} word={word} />
                          ) : word === '_' ? (
                            <span className="me-3 mb-1" key={word_i} style={{minHeight: '34px'}} />
                          ) : word[0] === '~' ? (
                            <TaskItemDynamic
                              key={word_i}
                              word={word}
                              selectedWord={selectedWord}
                              setSelectedWord={setSelectedWord}
                              onChange={v => {
                                setAnswers(
                                  answers.map((a, a_i) =>
                                    indexOfFirstTask + answer_i === a_i
                                      ? {
                                          ...a,
                                          words: a.words.map((w, w_i) => (w_i === word_i ? '~' + v : w)),
                                        }
                                      : a,
                                  ),
                                );
                              }}
                            />
                          ) : null,
                        )}
                      </div>
                      {showHints && answer.hint ? (
                        <div className="text-dark px-2 py-1" style={{fontSize: 14}}>
                          {answer.hint}
                        </div>
                      ) : null}
                    </div>
                    <div>
                      {answer.isRight !== undefined &&
                        (answer.isRight ? <Icon name="check" color="success" /> : <Icon name="times" color="danger" />)}
                    </div>
                  </div>
                ))}
              </div>
              <div className="font-2 mb-2 text-muted text-center mt-4">
                Для прохождения нужно {kindData[kind].pass} правильных ответа
              </div>
              <div className="text-center mt-4">
                <button
                  className="btn btn-sm btn-primary me-3"
                  onClick={e => setCurrentPage(currentPage - 1)}
                  disabled={1 === currentPage}
                >
                  <Icon name="chevron-left" />
                </button>
                {study && (
                  <button
                    className="btn btn-primary btn-sm me-3"
                    onClick={e => {
                      e.preventDefault();
                      mutation({
                        variables: {
                          input: {
                            answers: answers
                              .map(x => ({study: study.id, task: x.task.id, words: x.words}))
                              .slice(0, indexOfLastTask),
                          },
                        },
                      });
                    }}
                  >
                    {loading === false ? 'Проверить' : 'Загрузка...'}
                  </button>
                )}
                <button
                  className="btn btn-sm btn-primary"
                  onClick={e => setCurrentPage(currentPage + 1)}
                  disabled={Math.ceil(answers.length / tasksPerPage) === currentPage}
                >
                  <Icon name="chevron-right" />
                </button>
              </div>
              <div className="text-center font-2 mt-2">
                Страница {currentPage} из {Math.ceil(answers.length / tasksPerPage)}
              </div>
            </div>
            <div className="col-lg-5 border">
              <div className="row h-100">
                {(hideAnswers
                  ? kind === 'VOCABULARY'
                    ? query.data.taskList[0].lesson.trialVariants
                    : query.data.taskList[0].lesson.finalVariants
                  : []
                ).map((item, index) => (
                  <TaskAnswerList
                    key={index}
                    items={item}
                    kind={kind}
                    answers={answers}
                    selectedWord={selectedWord}
                    onSelectedWord={setSelectedWord}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
        <div>
          {/* {kind === 'FINAL' && !study.trialPassed && (
            <div className="text-center mb-4 text-danger">
              Вы провалили тест пожалуйста пройдите обучение грамматики заново
            </div>
          )} */}
          {kind === 'FINAL' && study.finalPassed && (
            <div className="text-center mb-4 text-success">Вы прошли грамматику</div>
          )}
          {kind === 'VOCABULARY' && study.vocabularyPassed && (
            <div className="text-center mb-4 text-success">Вы успешно прошли тест</div>
          )}
          {kind === 'INTERMEDIATE' && study.intermediatePassed && (
            <div className="text-center mb-4 text-success">Вы успешно прошли повторение</div>
          )}
          {/* {kind === 'INTERMEDIATE' && study.intermediatePassed === false && !study.finalPassed && (
            <div className="text-center mb-4 text-danger">Вы должны повторно пройти обучение грамматики</div>
          )} */}
          <div className="row justify-content-center gx-3">
            {kind === 'TRIAL' && study.trialPassed && (
              <div className="col-auto final-test">
                <Link replace to={`/my-lessons/${lesson.id}/grammar/final-test`} className="ms-3 btn btn-primary">
                  Начать финальный тест
                </Link>
              </div>
            )}
            {/* {kind === 'FINAL' && !study.trialPassed && (
              <div className="col-auto">
                <Link replace to={`/my-lessons/${lesson.id}/grammar`} className="ms-3 btn btn-primary">
                  Пройти грамматику заново
                </Link>
              </div>
            )} */}
            {kind !== 'INTERMEDIATE' && (
              <div className="col-auto">
                <Link to={`/my-lessons/${lesson.id}/${kindData[kind].back}`} replace className="btn btn-light ms-3">
                  Назад
                </Link>
              </div>
            )}
          </div>
        </div>
      </DndProvider>
    )
  );
};

export default TaskList;
